import { router } from 'expo-router';

import LightRatingExplanationBottomSheet from '@/components/bottomSheets/LightRatingExplanationBottomSheet';

const LightRatingExplanation = () => {
  const isPresented = router.canGoBack();

  return (
    <LightRatingExplanationBottomSheet
      onCloseTap={() => {
        isPresented && router.navigate('../');
      }}
    />
  );
};

export default LightRatingExplanation;
